import styled from 'styled-components';
import { CardS } from '../../GlobalStyles';

export const WrapperS = styled(CardS)`
  text-align: center;
  width: 100%;
  height: 100%;
`;

export const MessageWrapperS = styled.div`
  text-align: center;
  width: 800px;
  margin: 0 auto;
  p {
    text-align: start;
  }
  a {
    color: blue;
    text-decoration: underline;
  }
`;
